
import { Component, Getter, Action, Prop, mixins } from "nuxt-property-decorator"
import { extend, ValidationProvider } from "vee-validate"
import { required } from "vee-validate/dist/rules"
import Blocks from "~/mixins/blocks"
import { SET_DELIVERY_ADDRESS, SET_LISTING } from "~/store/listing/actions"
import { GET_DELIVERY_ADDRESS } from "~/store/listing/getters"
import InitialListing from "~/store/listing/state"
import { placeToAddress } from "~/scripts/convert"

@Component({
  components: { ValidationProvider }
})
export default class NewLocationDeliveryInput extends mixins(Blocks) {
  @Prop({ required: true, type: Object }) block: Record<string, any>
  @Prop({ default: false, type: Boolean }) virgin: boolean
  @Prop({ default: true, type: Boolean }) lazy: boolean
  @Prop({ default: false, type: Boolean }) validation: boolean

  @Getter(GET_DELIVERY_ADDRESS, { namespace: "listing" }) getDeliveryAddress: Address | null
  @Action(SET_DELIVERY_ADDRESS, { namespace: "listing" }) setDeliveryAddress: Function
  @Action(SET_LISTING, { namespace: "listing" }) setListing: Function

  created() {
    if (this.validation) {
      extend("required", required)
    }
    this.setListing(InitialListing())
  }

  get attributes() {
    return this.virgin ? null : this.Blocks_getAttributes(this.block)
  }

  // eslint-disable-next-line no-undef
  setDeliveryPlace(place: google.maps.places.PlaceResult | null) {
    this.setDeliveryAddress(place !== null ? placeToAddress(place) : null)
  }
}
